/**
 * Fonts exposed in Studio / NLE pickers.
 * Keep in sync with backend/utils/studioFonts.js and mobile/src/utils/studioFonts.js.
 */
export const STUDIO_FONT_NAME_PATTERNS = [
  /tiktok/i,
  /source\s*serif/i,
  /bootzy/i,
  /fontsri/i,
];

export function fontNameMatchesAllowlist(name) {
  const n = String(name || '').trim();
  if (!n) return false;
  return STUDIO_FONT_NAME_PATTERNS.some((re) => re.test(n));
}

export function filterStudioFonts(fonts) {
  return (Array.isArray(fonts) ? fonts : []).filter((f) => fontNameMatchesAllowlist(f?.name));
}
